/*
  Отзывы в каталоге: сортировка «Top rated» и фильтр «With reviews».

  Ни того, ни другого Shopify штатно не умеет: рейтинг и число отзывов —
  это метаполя (`reviews.rating`, `reviews.rating_count`, их заполняет Loox),
  а встроенные сортировка и фильтры по метаполям не работают.

  Поэтому оба элемента собраны здесь: скрипт забирает всю коллекцию служебным
  видом `?view=sortdata`, отбирает и раскладывает карточки сам, после чего
  перерисовывает сетку. Фильтры самой темы при этом сохраняются — параметры
  адреса уходят в служебный вид как есть.
*/
(function () {
  const SORT_VALUE = 'rating-descending';
  const SORT_LABEL = 'Top rated';
  const FILTER_PARAM = 'reviewed';
  const FILTER_LABEL = 'With reviews';
  const PRICE_PARAM = 'price';
  const SHOW_PARAM = 'show';
  const PER_PAGE = 50;
  const MAX_PAGES = 40;
  /* Границы в единицах валюты витрины: Shopify отдаёт цены в копейках. */
  const PRICE_STEPS = [2500, 5000, 10000];
  /* 48 вместо 60: постраничная выдача Shopify не берёт больше 50 за раз,
     а шаг настройки темы кратен четырём. */
  /* 20 — размер страницы самого шаблона, поэтому для него служебный вид не
     нужен. 40 — второй вариант. Больше 50 постраничная выдача Shopify не берёт. */
  const BASE_PAGE_SIZE = 20;
  const SHOW_STEPS = [20, 40];

  const grid = () => document.getElementById('product-grid');
  const sortSelects = () => document.querySelectorAll('select[name="sort_by"]');
  const counters = () => document.querySelectorAll('#ProductCountDesktop, #ProductCountMobile');
  const params = () => new URL(window.location.href).searchParams;
  const sortActive = () => params().get('sort_by') === SORT_VALUE;
  const filterActive = () => params().get(FILTER_PARAM) === '1';
  const priceRange = () => {
    const raw = params().get(PRICE_PARAM) || '';
    const [from, to] = raw.split('-');
    if (!raw || Number.isNaN(parseInt(from, 10))) return null;
    return { from: parseInt(from, 10), to: to ? parseInt(to, 10) : Infinity };
  };
  /* Принимаем только заранее известные размеры: иначе чужое или устаревшее
     значение в адресе (когда-то здесь был вариант «all») заставит скрипт
     отрисовать весь каталог разом. Всё непонятное — обычная выдача темы. */
  const shownLimit = () => {
    /* Размер выдачи живёт в служебном виде `?view=show40`; свой параметр
       остаётся только как запасной — по старым ссылкам. Без чтения `view`
       выбранный размер терялся, когда сверху включали отбор по отзывам. */
    const view = (params().get('view') || '').match(/^show(\d+)$/);
    const raw = view ? view[1] : params().get(SHOW_PARAM);
    const value = parseInt(raw, 10);
    return SHOW_STEPS.indexOf(value) === -1 ? 0 : value;
  };
  const showActive = () => shownLimit() > 0;
  /* Отбор, после которого выдача становится короче: счётчик и «показать ещё»
     считаются иначе, чем при одном лишь размере выдачи. */
  const narrowing = () => filterActive() || !!priceRange();
  /* Свои элементы работают только когда есть что показывать сверх обычной
     выдачи темы: иначе не трогаем страницу и не ждём загрузки. */
  /* Размер страницы обрабатывает сам Shopify служебным видом, поэтому в этот
     список он не входит. Иначе скрипт подменял уже правильную серверную выдачу
     своим лениво подгруженным списком: успевала приехать одна служебная
     страница на 50 товаров, и из 781 оставалось 50 — три страницы вместо сорока. */
  const anyActive = () => sortActive() || filterActive() || !!priceRange();

  let applying = false;
  /* Тема пересобирает адрес по своей форме и выбрасывает чужие параметры,
     поэтому наш выбор храним отдельно и возвращаем после её перерисовки. */
  let filterWanted = false;
  /* Разметка сетки, как её отдал сервер: чтобы снять наш фильтр без перезагрузки. */
  let original = null;

  /* ── Элементы управления ──────────────────────────────────────────────── */

  function addSortOption() {
    sortSelects().forEach((select) => {
      if (!select.querySelector(`option[value="${SORT_VALUE}"]`)) {
        const option = document.createElement('option');
        option.value = SORT_VALUE;
        option.textContent = SORT_LABEL;
        select.appendChild(option);
      }
      if (sortActive()) select.value = SORT_VALUE;
    });
  }

  /* Соседи по строке фильтров живут с высотой строки 21px и нижним отступом
     15px — без них наша подпись съезжает вниз. Стилей на десяток строк
     отдельный файл не заслуживает. */
  function addStyles() {
    if (document.getElementById('reviews-facet-styles')) return;
    const style = document.createElement('style');
    style.id = 'reviews-facet-styles';
    style.textContent = `
      .reviews-facet { display: inline-flex; align-items: center; gap: 0.8rem;
        margin: 0 2rem 1.5rem 0.5rem; padding: 0; border: 0; background: none;
        font-family: inherit; font-size: 1.4rem; line-height: 21px;
        letter-spacing: 0.224rem; text-transform: uppercase;
        color: rgb(var(--color-foreground)); white-space: nowrap; cursor: pointer; }
      .reviews-facet__box { display: inline-block; width: 1.5rem; height: 1.5rem;
        border: 0.1rem solid rgba(var(--color-foreground), 0.55);
        border-radius: 0.2rem; position: relative; flex: 0 0 auto; }
      .reviews-facet[aria-pressed="true"] .reviews-facet__box {
        background: rgb(var(--color-foreground));
        border-color: rgb(var(--color-foreground)); }
      .reviews-facet[aria-pressed="true"] .reviews-facet__box::after {
        content: ''; position: absolute; left: 0.4rem; top: 0.1rem;
        width: 0.4rem; height: 0.8rem; border: solid rgb(var(--color-background));
        border-width: 0 0.2rem 0.2rem 0; transform: rotate(45deg); }
      .reviews-facet:focus-visible { outline: 0.2rem solid rgb(var(--color-foreground));
        outline-offset: 0.3rem; }
      .reviews-facet-bar { flex: 0 0 100%; display: flex; align-items: center;
        flex-wrap: wrap; gap: 0 2.5rem; margin: 0 0 1.5rem; }
      /* Форма фильтров — сетка из трёх колонок: слева фильтры темы, справа
         сортировка и счётчик. После отключения фильтра Availability первая
         колонка опустела, и наша строка сваливалась под неё вторым рядом.
         Сажаем её в освободившуюся ячейку. Строка только для широких экранов:
         сама форма скрыта классом small-hide. */
      .facets__form .reviews-facet-bar { grid-column: 1; grid-row: 1;
        margin-bottom: 0; }
      .reviews-facet-bar .reviews-facet { margin: 0; }
      /* Блок темы тянется на всю оставшуюся ширину и прижимает содержимое
         вправо — в своей строке он должен вести себя как обычный элемент. */
      .reviews-facet-bar .facet-filters__field { flex: 0 0 auto; width: auto;
        justify-content: flex-start; }
      /* Между сортировкой и размером выдачи у темы отступа нет вовсе:
         галочка списка вплотную упиралась в подпись «Show». */
      .facet-filters.sorting .facet-filters__field + .facet-filters__field {
        margin-left: 3rem; }
      .mobile-facets .reviews-facet { margin: 1.2rem 2rem; }
      /* .mobile-facets__main — флекс-колонка, и поля темы приходят с
         flex: 1 1 auto: в колонке это растягивает их по высоте. Каждое
         занимало 220 пикселей вместо 21, между строками зияли пустоты. */
      .mobile-facets__main .facet-filters__field,
      .mobile-facets__main .reviews-facet {
        flex: 0 0 auto;
        margin: 1.2rem 2rem;
        justify-content: flex-start;
      }
    `;
    document.head.appendChild(style);
  }

  /* В мобильной панели свои элементы должны стоять до кнопок «Remove all» и
     «Apply», иначе они оказываются под ними — как будто отвалились. */
  function place(holder, node) {
    const footer = holder.querySelector(':scope > .mobile-facets__footer');
    if (footer) holder.insertBefore(node, footer);
    else holder.appendChild(node);
  }

  /* Размер страницы живёт в служебном виде `?view=show40`, а форма фильтров темы
     собирает адрес заново из своих полей — и параметр пропадал при каждом
     «Apply». Кладём его в форму скрытым полем, тогда он переживает применение
     фильтров. */
  function keepView() {
    const view = params().get('view') || '';
    document.querySelectorAll('form#FacetFiltersForm, .mobile-facets__form, form.facets__form')
      .forEach((form) => {
        let hidden = form.querySelector('input[name="view"][data-keep-view]');
        if (!view) { if (hidden) hidden.remove(); return; }
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'view';
          hidden.dataset.keepView = '1';
          form.appendChild(hidden);
        }
        hidden.value = view;
      });
  }

  /* Свой блок в форме фильтров. Раньше он занимал отдельную строку: рядом с
     фильтром Availability наши элементы не помещались — на строку оставалось
     488 пикселей, а требовалось 589, и цена переносилась вниз в одиночку.
     Availability отключён в шаблонах, первая колонка сетки освободилась, и
     блок встаёт в неё (см. правило `.facets__form .reviews-facet-bar`).
     Вернут фильтры темы — вернуть и `grid-row: 2`. */
  function facetBar() {
    const form = document.querySelector('.facets__form');
    if (!form) return null;
    let bar = form.querySelector('.reviews-facet-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'reviews-facet-bar';
      form.appendChild(bar);
    }
    return bar;
  }

  function addFilterControl() {
    const bar = facetBar();
    const holders = bar ? [bar] : [];
    document.querySelectorAll('.mobile-facets__main').forEach((el) => holders.push(el));
    holders.forEach((holder) => {
      let control = holder.querySelector('.reviews-facet');
      if (!control) {
        control = document.createElement('button');
        /* Именно button, а не checkbox в label: чекбокс внутри формы фильтров
           заставляет тему отправлять форму по событию `input`. */
        control.type = 'button';
        control.className = 'reviews-facet';
        control.innerHTML = `<span class="reviews-facet__box"></span>${FILTER_LABEL}`;
        control.addEventListener('click', onFilterToggle);
        place(holder, control);
      }
      control.setAttribute('aria-pressed', filterActive() ? 'true' : 'false');
    });
  }

  function money(cents) {
    const currency = (window.Shopify && window.Shopify.currency
      && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency, maximumFractionDigits: 0,
      }).format(cents / 100);
    } catch (error) {
      return `${Math.round(cents / 100)}`;
    }
  }

  /* Галочка списка у темы своя, нарисованная; системная стрелка браузера
     рядом с ней выглядит чужой. Берём тот же значок. */
  const CARET = '<svg class="icon icon-caret" viewBox="0 0 10 6">'
    + '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 '
    + '0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 '
    + '0 0-.708" clip-rule="evenodd"></path></svg>';

  let fieldSeq = 0;

  /* Выпадающий список повторяет разметку «Sort by» темы: подпись, шрифт,
     высота и галочка совпадают сами, без подгонки стилями. Класс
     `facet-filters__sort` обязателен — без него `select__select` даёт
     крупный серый бокс в 45 пикселей вместо плоской строки. */
  function addSelect(holder, name, label, options, current) {
    let field = holder.querySelector(`[data-facet-select="${name}"]`);
    if (!field) {
      const id = `FacetSelect-${name}-${fieldSeq}`;
      fieldSeq += 1;
      field = document.createElement('div');
      field.className = 'facet-filters__field';
      field.dataset.facetSelect = name;
      field.innerHTML =
        `<h2 class="facet-filters__label caption-large text-body">`
        + `<label for="${id}">${label}</label></h2>`
        + `<div class="select"><select id="${id}"`
        + ` class="facet-filters__sort select__select caption-large"></select>`
        + `${CARET}</div>`;
      const control = field.querySelector('select');
      /* `<select>` шлёт `input` перед `change`, а форма фильтров темы слушает
         именно `input`. Без этой заглушки выбор уходил на сервер, тема
         пересобирала адрес по своей форме и выбрасывала наш параметр —
         размер выдачи и цена молча не срабатывали. */
      control.addEventListener('input', (event) => event.stopPropagation());
      control.addEventListener('change', (event) => {
        event.stopPropagation();
        onSelectChange(name, event.target.value);
      });
      place(holder, field);
    }
    const select = field.querySelector('select');
    const wanted = options.map((o) => o.value).join('|');
    if (select.dataset.options !== wanted) {
      select.dataset.options = wanted;
      select.innerHTML = options
        .map((o) => `<option value="${o.value}">${o.label}</option>`).join('');
    }
    select.value = current || '';
  }

  function priceOptions() {
    const steps = PRICE_STEPS;
    const options = [{ value: '', label: 'Any price' }];
    steps.forEach((step, index) => {
      const from = index === 0 ? 0 : steps[index - 1];
      options.push({ value: `${from}-${step}`,
                     label: index === 0 ? `< ${money(step)}`
                                        : `${money(from)}–${money(step)}` });
    });
    options.push({ value: `${steps[steps.length - 1]}-`,
                   label: `> ${money(steps[steps.length - 1])}` });
    return options;
  }

  /* Строка фильтров узкая: если сложить все элементы слева, они переносятся
     на вторую строку. Поэтому цена уходит к фильтрам, а размер выдачи —
     к сортировке справа, перед счётчиком товаров. */
  function addExtraControls() {
    const bar = facetBar();
    const holders = bar ? [bar] : [];
    document.querySelectorAll('.mobile-facets__main').forEach((el) => holders.push(el));
    holders.forEach((holder) => {
      addSelect(holder, PRICE_PARAM, 'Price:', priceOptions(),
                params().get(PRICE_PARAM) || '');
    });
    /* «Default» убран: покупателю нужно видеть число, а не слово. */
    const showOptions = SHOW_STEPS.map((n) => ({ value: String(n), label: String(n) }));
    /* Текущий размер берём из служебного вида, а не из своего параметра. */
    const view = (params().get('view') || '').match(/^show(\d+)$/);
    const current = view ? view[1] : String(BASE_PAGE_SIZE);
    document.querySelectorAll('.facet-filters.sorting, .mobile-facets__main')
      .forEach((holder) => {
        addSelect(holder, SHOW_PARAM, 'Show:', showOptions, current);
      });
  }

  /* Размер выдачи меняем не подменой сетки, а служебным видом: Shopify отдаёт
     страницу нужного размера сам, и работает штатная постраничная навигация.
     Своя сетка с кнопкой «показать ещё» остаётся только там, где без неё никак —
     когда включён отбор по отзывам, цене или сортировка Top rated: их Shopify
     не умеет, и страницы всё равно пришлось бы считать самим. */
  function goToPageSize(value) {
    const url = new URL(window.location.href);
    if (value && parseInt(value, 10) !== BASE_PAGE_SIZE) {
      url.searchParams.set('view', 'show' + value);
    } else {
      url.searchParams.delete('view');
    }
    url.searchParams.delete(SHOW_PARAM);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }

  function onSelectChange(name, value) {
    if (name === SHOW_PARAM && !sortActive() && !narrowing()) {
      goToPageSize(value);
      return;
    }
    remember();
    setParam(name, value || null);
    if (anyActive()) apply();
    else restore();
  }

  /* ── Данные ───────────────────────────────────────────────────────────── */

  /* Тот же путь и те же фильтры темы, без страницы и без наших параметров. */
  function sortDataUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.delete('sort_by');
    url.searchParams.delete(FILTER_PARAM);
    url.searchParams.set('view', 'sortdata');
    if (page > 1) url.searchParams.set('page', page);
    else url.searchParams.delete('page');
    return url.toString();
  }

  async function fetchPage(page) {
    const response = await fetch(sortDataUrl(page));
    if (!response.ok) return null;
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const holder = html.getElementById('RatingSortPage');
    if (!holder) return null;
    return { items: [...holder.querySelectorAll('li.grid__item')],
             hasNext: !!holder.dataset.next };
  }

  /* Сколько товаров в выдаче темы. Свой счётчик мы переписываем
     («20 of 675 products»), поэтому число берём из нетронутой разметки —
     её хранит `remember()`; последнее число в строке и есть итог. */
  function totalProducts() {
    const live = document.querySelector('#ProductCountDesktop, #ProductCountMobile');
    const text = original ? original.count : ((live && live.textContent) || '');
    const numbers = text.match(/\d[\d\s,.]*/g);
    return numbers ? parseInt(numbers[numbers.length - 1].replace(/\D/g, ''), 10) : 0;
  }

  /* Уже загруженные страницы служебного вида. Ключ — адрес без наших
     параметров: сменилась коллекция или фильтр темы — список набирается заново. */
  let cache = null;

  function cacheStore() {
    const url = new URL(window.location.href);
    ['sort_by', FILTER_PARAM, PRICE_PARAM, SHOW_PARAM, 'page']
      .forEach((name) => url.searchParams.delete(name));
    const key = url.toString();
    if (!cache || cache.key !== key) cache = { key, items: [], pages: 0, done: false };
    return cache;
  }

  /* Сколько страниц дозапросить. При известном пределе берём ровно столько,
     сколько нужно; при неизвестном — всю выдачу разом, она уже посчитана. */
  function pagesToFetch(need, have) {
    if (Number.isFinite(need)) return Math.max(1, Math.ceil(need / PER_PAGE) - have);
    const total = totalProducts();
    if (!total) return 1;
    return Math.max(1, Math.min(Math.ceil(total / PER_PAGE), MAX_PAGES) - have);
  }

  /* Догружает служебный вид, пока не наберётся `need` карточек.
     Ради двадцати товаров каталог из 675 больше не скачивается целиком. */
  async function ensureItems(need) {
    const store = cacheStore();
    while (!store.done && store.items.length < need) {
      const from = store.pages + 1;
      const batch = await Promise.all(
        Array.from({ length: pagesToFetch(need, store.pages) },
                   (unused, i) => fetchPage(from + i)));
      for (let i = 0; i < batch.length; i += 1) {
        const part = batch[i];
        if (!part) { store.done = true; break; }
        store.items.push(...part.items);
        store.pages = from + i;
        if (!part.hasNext) { store.done = true; break; }
      }
      /* Ни одной новой страницы — дальше идти некуда. */
      if (store.pages < from) store.done = true;
      if (store.pages >= MAX_PAGES) store.done = true;
    }
    return store.items;
  }

  const reviewCount = (item) => parseInt(item.dataset.ratingCount, 10) || 0;

  /* Сначала товары с отзывами: выше оценка, при равной — больше отзывов.
     Товары без отзывов уходят в конец, сохраняя исходный порядок. */
  function byRating(a, b) {
    const ca = reviewCount(a);
    const cb = reviewCount(b);
    if (!ca && !cb) return 0;
    if (!ca) return 1;
    if (!cb) return -1;
    return (parseFloat(b.dataset.rating) || 0) - (parseFloat(a.dataset.rating) || 0) || cb - ca;
  }

  /* ── Отрисовка ────────────────────────────────────────────────────────── */

  /* shown — сколько нарисовано, matched — сколько прошло наши фильтры,
     total — сколько в выдаче темы. Иначе «6 products» вместо «6 из 54». */
  function setCount(shown, matched, total) {
    const word = (n) => (n === 1 ? 'product' : 'products');
    let text;
    if (matched < total) text = `${matched} of ${total} ${word(total)}`;
    else text = `${total} ${word(total)}`;
    counters().forEach((el) => { el.textContent = text; });
  }

  function showPagination(visible) {
    document.querySelectorAll('.pagination-wrapper').forEach((el) => {
      el.style.display = visible ? '' : 'none';
    });
  }

  /* Сетка «наша», если карточки несут данные рейтинга: тема их не проставляет. */
  function gridIsOurs() {
    const first = grid() && grid().firstElementChild;
    return !!first && (first.dataset.rating !== undefined || first.dataset.empty === '1');
  }

  function remember() {
    const target = grid();
    if (target && !gridIsOurs()) {
      const counter = document.querySelector('#ProductCountDesktop');
      const pager = document.querySelector('.pagination-wrapper');
      original = {
        html: target.innerHTML,
        count: counter ? counter.textContent : '',
        pager: pager ? pager.outerHTML : '',
        /* размер страницы темы: столько карточек она отдала на первой странице */
        pageSize: target.querySelectorAll('li.grid__item').length || 16,
      };
    }
  }

  function restore() {
    /* Возвращаем выдачу темы целиком вместе с её постраничной навигацией:
       наша была построена по своему списку и к выдаче темы не относится. */
    const target = grid();
    if (!target || !original) {
      window.location.reload();
      return;
    }
    target.innerHTML = original.html;
    counters().forEach((el) => { el.textContent = original.count; });
    setPage(1);
    const pager = document.querySelector('.pagination-wrapper');
    if (pager && original.pager) pager.outerHTML = original.pager;
    else if (pager) pager.remove();
    showPagination(true);
  }

  /* Страницы для своей сетки.

     Под отбором по отзывам, цене или сортировкой Top rated список собирается на
     стороне покупателя: Shopify так не умеет, и его постраничная навигация этому
     списку не соответствует. Раньше здесь стояла кнопка «показать ещё» — проще,
     но покупателю привычнее страницы, поэтому рисуем их сами, той же разметкой
     темы, и переключаем без перезагрузки: список уже в кэше. */

  const CARET_SVG = '<span class="svg-wrapper"><svg class="icon icon-caret" '
    + 'viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" '
    + 'd="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 '
    + '0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></span>';

  const currentPage = () => Math.max(1, parseInt(params().get('page'), 10) || 1);

  function setPage(page) {
    const url = new URL(window.location.href);
    if (page > 1) url.searchParams.set('page', page);
    else url.searchParams.delete('page');
    window.history.replaceState({}, '', url.toString());
  }

  /* Номера страниц с многоточиями — как у темы: первая, последняя, соседи. */
  function pageParts(total, page) {
    const keep = new Set([1, total, page, page - 1, page + 1]);
    if (page <= 3) [2, 3, 4].forEach((n) => keep.add(n));
    if (page >= total - 2) [total - 1, total - 2, total - 3].forEach((n) => keep.add(n));
    const nums = [...keep].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
    const parts = [];
    nums.forEach((n, i) => {
      if (i && n - nums[i - 1] > 1) parts.push(null);
      parts.push(n);
    });
    return parts;
  }

  function renderPages(target, totalItems, limit, page) {
    const holder = target.parentElement;
    let wrap = document.querySelector('.pagination-wrapper');
    const totalPages = limit ? Math.ceil(totalItems / limit) : 1;
    if (totalPages <= 1) {
      if (wrap) wrap.remove();
      return;
    }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'pagination-wrapper';
      holder.appendChild(wrap);
    }
    wrap.style.display = '';
    wrap.dataset.page = page;

    const item = (n) => (n === page
      ? '<li><a role="link" aria-disabled="true" class="pagination__item '
        + 'pagination__item--current light" aria-current="page">' + n + '</a></li>'
      : '<li><a href="#" data-page="' + n + '" class="pagination__item link">' + n + '</a></li>');

    let html = '<nav class="pagination" role="navigation"><ul class="pagination__list list-unstyled" role="list">';
    if (page > 1) {
      html += '<li><a href="#" data-page="' + (page - 1) + '" class="pagination__item '
        + 'pagination__item--next pagination__item-arrow link motion-reduce">' + CARET_SVG + '</a></li>';
    }
    pageParts(totalPages, page).forEach((n) => {
      html += n === null ? '<li><span class="pagination__item">…</span></li>' : item(n);
    });
    if (page < totalPages) {
      html += '<li><a href="#" data-page="' + (page + 1) + '" class="pagination__item '
        + 'pagination__item--prev pagination__item-arrow link motion-reduce">' + CARET_SVG + '</a></li>';
    }
    wrap.innerHTML = html + '</ul></nav>';

    wrap.querySelectorAll('a[data-page]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        setPage(parseInt(link.dataset.page, 10));
        apply();
        const top = document.getElementById('ProductGridContainer');
        if (top) window.scrollTo({ top: window.scrollY + top.getBoundingClientRect().top - 100 });
      });
    });
  }

  function emptyMessage() {
    const li = document.createElement('li');
    li.className = 'grid__item';
    li.dataset.empty = '1';
    li.style.gridColumn = '1 / -1';
    li.innerHTML = '<p class="title title--primary">No products with reviews yet.</p>';
    return li;
  }

  /* Отбор и порядок — отдельно от отрисовки: тем же путём идёт «показать ещё». */
  function selectItems(all) {
    let items = all.slice();
    if (filterActive()) items = items.filter((item) => reviewCount(item) > 0);
    const range = priceRange();
    if (range) {
      items = items.filter((item) => {
        const price = parseInt(item.dataset.price, 10);
        return Number.isFinite(price) && price >= range.from && price < range.to;
      });
    }
    if (sortActive()) items.sort(byRating);
    return items;
  }

  /* Отзывы, цена и сортировка считаются по всему списку — его нужно набрать
     целиком. Одному лишь размеру выдачи хватает первых карточек. */
  function needed() {
    if (sortActive() || narrowing()) return Infinity;
    return shownLimit() || Infinity;
  }

  async function apply() {
    const target = grid();
    if (!target || applying) return;
    applying = true;
    const container = document.getElementById('ProductGridContainer');
    if (container) container.classList.add('loading');

    try {
      const total = totalProducts();
      const all = await ensureItems(needed());
      if (!all.length) return;
      const items = selectItems(all);
      /* Без наших фильтров отобранное равно всей выдаче темы, даже когда
         подгружена лишь её часть — иначе счётчик пишет «20 of 50». */
      const matched = narrowing() ? items.length : Math.max(items.length, total);

      /* Размер страницы: выбранный покупателем, иначе тот, что даёт тема. */
      const limit = shownLimit() || BASE_PAGE_SIZE;
      const pages = Math.max(1, Math.ceil(items.length / limit));
      const page = Math.min(currentPage(), pages);
      if (page !== currentPage()) setPage(page);
      const visible = items.slice((page - 1) * limit, page * limit);
      target.replaceChildren(...(visible.length ? visible : [emptyMessage()]));
      setCount(visible.length, matched, Math.max(total, matched));
      renderPages(target, items.length, limit, page);
    } catch (error) {
      console.error('[rating-sort] не удалось применить отзывы к каталогу', error);
    } finally {
      if (container) container.classList.remove('loading');
      applying = false;
    }
  }

  /* ── События ──────────────────────────────────────────────────────────── */

  function setParam(name, value) {
    const url = new URL(window.location.href);
    if (value === null) url.searchParams.delete(name);
    else url.searchParams.set(name, value);
    url.searchParams.delete('page');
    window.history.replaceState({}, '', url.toString());
  }

  function onSortChange(event) {
    const select = event.target;
    if (!select.matches || !select.matches('select[name="sort_by"]')) return;
    if (select.value !== SORT_VALUE) return;
    /* Не даём форме фильтров уйти на сервер с сортировкой, которой там нет. */
    event.stopPropagation();
    event.preventDefault();
    remember();
    setParam('sort_by', SORT_VALUE);
    apply();
  }

  function onFilterToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const pressed = event.currentTarget.getAttribute('aria-pressed') !== 'true';
    filterWanted = pressed;
    remember();
    setParam(FILTER_PARAM, pressed ? '1' : null);
    document.querySelectorAll('.reviews-facet').forEach((el) => {
      el.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
    if (pressed || sortActive()) apply();
    else restore();
  }

  function init() {
    if (!grid()) return;
    if (filterActive()) filterWanted = true;
    else if (filterWanted) setParam(FILTER_PARAM, '1');
    addStyles();
    addSortOption();
    addFilterControl();
    addExtraControls();
    keepView();
    remember();
    if (anyActive() && !gridIsOurs()) apply();
  }

  /* Та же беда у списка сортировки темы: `input` доходит до формы раньше, чем
     мы успеваем отменить `change`, и «Top rated» уезжал на сервер, которому
     такая сортировка неизвестна. Гасим оба события в фазе погружения. */
  function onSortInput(event) {
    const select = event.target;
    if (!select.matches || !select.matches('select[name="sort_by"]')) return;
    if (select.value !== SORT_VALUE) return;
    event.stopPropagation();
  }

  /* Перехватываем в фазе погружения — раньше обработчика фильтров темы. */
  document.addEventListener('input', onSortInput, true);
  document.addEventListener('change', onSortChange, true);
  document.addEventListener('shopify:section:load', init);

  /* При фильтрации тема заменяет сетку и панель фильтров разметкой с сервера —
     наши элементы и порядок при этом пропадают. Событий об этом она не шлёт,
     поэтому следим за самой перерисовкой. */
  let pending;
  new MutationObserver(() => {
    if (applying) return;
    clearTimeout(pending);
    pending = setTimeout(init, 150);
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
